import * as React from 'react';
import DashboardLayout from '../../../shared/LayoutContainers/DashboardLayout';
import DashboardNavbar from '../../../shared/Navbars/DashboardNavbar';
import ContratacaoV2Form from './ContratacaoV2Form';

function ContratacaoV2ListScreen() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ContratacaoV2Form />
    </DashboardLayout>
  );
}

export default ContratacaoV2ListScreen;
